export default "__VITE_ASSET__ebc572f5__"